import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const vehicles = [
  {
    id: 1,
    name: 'Dongfeng Nammi 01',
    description: 'Voiture 100% électrique, moderne et confortable pour tous vos déplacements au Sénégal.',
    capacity: 'Max. 4 passagers',
    image: 'https://images.bitauto.com/appimage-1980-w1/mapi/media/2024/01/08/f4c4c6d6a8ef4c3f9c7f1c3a9b5e8d2f.jpg',
    features: ['100% Électrique', 'Climatisation', 'Confortable', 'Écologique']
  },
  {
    id: 2,
    name: 'Dongfeng Nammi 01 - Intérieur',
    description: 'Profitez d\'un intérieur spacieux et moderne avec toutes les commodités pour un trajet agréable.',
    capacity: 'Max. 4 passagers',
    image: 'https://images.bitauto.com/appimage-1980-w1/mapi/media/2024/01/08/a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6.jpg',
    features: ['Écran tactile', 'Sièges confortables', 'Espace bagages', 'USB']
  }
];

const FleetPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero */}
      <section className="pt-24 sm:pt-32 pb-12 sm:pb-16 bg-[#0f0f10]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 text-center">
          <h1
            className="text-3xl sm:text-4xl md:text-5xl text-white mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Notre Flotte
          </h1>
          <p className="text-gray-400 max-w-xl mx-auto text-sm sm:text-base">
            Découvrez notre véhicule électrique Dongfeng Nammi 01 - Moderne, confortable et écologique.
          </p>
        </div>
      </section>

      {/* Main Vehicle Showcase */}
      <section className="py-12 sm:py-20 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12 sm:mb-16">
            <div>
              <span className="text-sm text-green-600 font-medium mb-2 inline-block">100% ÉLECTRIQUE</span>
              <h2 
                className="text-3xl md:text-4xl text-gray-900 mb-6"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Dongfeng Nammi 01
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                Notre flotte est composée de la Dongfeng Nammi 01, une voiture 100% électrique 
                offrant un confort optimal et une climatisation efficace pour tous vos trajets 
                au Sénégal. Voyagez de manière écologique sans compromis sur le confort.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span className="text-gray-700">Voiture 100% électrique</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span className="text-gray-700">Climatisation performante</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span className="text-gray-700">Jusqu'à 4 passagers</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span className="text-gray-700">Espace bagages généreux</span>
                </li>
              </ul>
              <Link
                to="/contact"
                className="inline-block px-8 py-3 bg-gray-900 text-white text-sm rounded hover:bg-gray-800 transition-colors"
              >
                Réserver maintenant
              </Link>
            </div>
            <div className="relative">
              <img
                src="https://global-img.bitauto.com/usercenter/autoalbum/20250429/25/w1200_yichecar_591976302520652.png.webp"
                alt="Dongfeng Nammi 01"
                className="w-full rounded-lg shadow-xl"
              />
              <div className="absolute -bottom-4 -left-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg">
                <span className="font-bold">⚡ 100% Électrique</span>
              </div>
            </div>
          </div>

          {/* Gallery */}
          <h3 className="text-xl sm:text-2xl text-gray-900 mb-6 sm:mb-8 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
            Galerie photos
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            <div className="overflow-hidden rounded-lg shadow-lg">
              <img
                src="https://global-img.bitauto.com/usercenter/autoalbum/20250409/506/w1200_yichecar_418880650657521.jpg.webp"
                alt="Nammi 01 - Intérieur"
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="overflow-hidden rounded-lg shadow-lg">
              <img
                src="https://global-img.bitauto.com/usercenter/autoalbum/20250429/25/w1200_yichecar_591976302520652.png.webp"
                alt="Nammi 01 - Vue extérieure"
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="overflow-hidden rounded-lg shadow-lg">
              <img
                src="https://global-img.bitauto.com/usercenter/autoalbum/20250409/506/w1200_yichecar_418880650657521.jpg.webp"
                alt="Nammi 01 - Tableau de bord"
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 bg-[#0f0f10]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 text-center">
          <h2 
            className="text-2xl md:text-3xl text-white mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Prêt à voyager en électrique ?
          </h2>
          <p className="text-gray-400 mb-8 max-w-xl mx-auto">
            Contactez-nous pour réserver votre trajet au Sénégal avec notre Dongfeng Nammi 01.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3 bg-white text-gray-900 rounded hover:bg-gray-100 transition-colors"
            >
              Demander un devis
            </Link>
            <a
              href="tel:+221774884254"
              className="px-8 py-3 border border-white text-white rounded hover:bg-white hover:text-gray-900 transition-colors"
            >
              Appeler : +221 77 488 42 54
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FleetPage;
